export function primaryDegreePlanStorageKey(userId: string): string {
  return `scarlet-sync:primary-degree-plan:v1:${userId}`;
}

export function resolvePrimaryDegreePlanId(plans: Array<{ id: number }>, savedValue: string | null): number | null {
  if (plans.length === 0) return null;
  const savedId = savedValue == null ? Number.NaN : Number(savedValue);
  return plans.some((plan) => plan.id === savedId) ? savedId : plans[0].id;
}
